var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 3.33341C3.33301 2.41294 4.0792 1.66675 4.99967 1.66675H11.6663C11.8873 1.66675 12.0993 1.75455 12.2556 1.91082L16.4223 6.07749C16.5785 6.23377 16.6663 6.44573 16.6663 6.66675V16.6667C16.6663 17.5872 15.9202 18.3334 14.9997 18.3334H4.99967C4.0792 18.3334 3.33301 17.5872 3.33301 16.6667V3.33341ZM14.6545 6.66675L11.6663 3.67859V6.66675H14.6545ZM9.99967 3.33341H4.99967V16.6667H14.9997V8.33342H10.833C10.3728 8.33342 9.99967 7.96032 9.99967 7.50008V3.33341ZM6.66634 10.8334C6.66634 10.3732 7.03944 10.0001 7.49967 10.0001H12.4997C12.9599 10.0001 13.333 10.3732 13.333 10.8334C13.333 11.2937 12.9599 11.6667 12.4997 11.6667H7.49967C7.03944 11.6667 6.66634 11.2937 6.66634 10.8334ZM6.66634 14.1667C6.66634 13.7065 7.03944 13.3334 7.49967 13.3334H12.4997C12.9599 13.3334 13.333 13.7065 13.333 14.1667C13.333 14.627 12.9599 15.0001 12.4997 15.0001H7.49967C7.03944 15.0001 6.66634 14.627 6.66634 14.1667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon_file.cd59f77f260adeae81f6b63ddaec8e3a.svg";
export { ForwardRef as ReactComponent };